import { visuallyHidden } from '@mui/utils';

import type { HeaderProps } from './Header.types';

export function Header({ id, children, ...props }: HeaderProps) {
  return (
    <legend id={id} style={visuallyHidden} {...props}>
      {children}
    </legend>
  );
}
